<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>购买次卡列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="align-items: flex-start;display: flex;justify-content: flex-start;justify-items: center;">
      <el-date-picker
        v-model="baseRequest.selectDate"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectKpiData"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-select value filterable v-model="selectAreaId" v-if="orgLevel == 1" placeholder="请选择区域" clearable
                 style="margin-left: 5px;width: 200px" size="mini" @change="getArea">
        <el-option
          v-for="item in area"
          :key="item.id"
          :label="item.orgName"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="selectOrgId" clearable value filterable placeholder="请选择门店"
                 style="margin-left: 5px;width: 200px" size="mini" @change="getShop"
                v-if="orgLevel < 3"
      >
        <el-option
          v-for="org in shop"
          :key="org.id"
          :label="org.orgName"
          :value="org.id">
        </el-option>
      </el-select>
      <el-button size="mini" @click="loadCustomerBuyCkList">查询</el-button>
    </div>
    <span style="color: #3a8ee6; font-size: x-small">次卡合计：{{czhj}}元</span>
    <el-table height="550px" :data="customerBuyCkList" fit border stripe="stripe"
              :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :cell-style="orderStateColor"
              :row-style="{height: '0'}" >
      <el-table-column
        align="center"
        fixed="fixed"
        label="操作" width="100">
        <template slot-scope="scope">
          <div style="display: flex;justify-content: space-evenly">
            <el-link type="primary" icon="iconfont icon-bianji"
                     :disabled="scope.row.state == 4"
                     @click="showModifyCustomerCk(scope.row)"></el-link>
            <el-link type="primary" icon="iconfont icon-zuofei"
                     :disabled="scope.row.buyDate != today || scope.row.syNum != scope.row.cardNum
                        || scope.row.state == 4"
                     @click="cancelCustomerCk(scope.row)"></el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="customerName"
        label="会员姓名" width="180">
      </el-table-column>
      <el-table-column
        align="center"
        prop="cardTypeName"
        label="次卡名称" width="180">
      </el-table-column>
      <el-table-column
        align="center"
        prop="cardNum"
        label="卡片次数" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="syNum"
        label="剩余次数" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="money"
        label="购买价格" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="state"
        :formatter="cardStateFormatter"
        label="状态" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="useTypeName"
        label="用途" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="shopName"
        label="所属门店" width="180">
      </el-table-column>
      <el-table-column
        align="center"
        prop="createTime"
        label="购买日期" width="180">
      </el-table-column>
      <el-table-column
        align="center"
        prop="validDate"
        label="有效期至" width="180">
      </el-table-column>
      <el-table-column
        align="center"
        prop="modifyValidDate"
        label="修改前有效期" width="180">
      </el-table-column>
      <el-table-column
        align="center"
        prop="modifyTime"
        label="修改日期" width="180">
      </el-table-column>
    </el-table>
<!--    <div style="margin-top: 3px;">-->
<!--      <el-pagination-->
<!--        @size-change="handleSizeChange"-->
<!--        @current-change="handleCurrentChange"-->
<!--        :current-page="currentPage"-->
<!--        :page-sizes="[10, 20, 30, 50]"-->
<!--        :page-size="pageSize"-->
<!--        layout="total, sizes, prev, pager, next, jumper"-->
<!--        :total="pageTotal">-->
<!--      </el-pagination>-->
<!--    </div>-->
    <el-dialog
      title="编辑次卡记录"
      :visible.sync="modifyCustomerCkDialogVisible"
      width="60%"
      style="position: absolute"
      @close="closeModifyCustomerCk"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card>
        <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
          <div style="width: 50%">
            <span style="width: 20%">卡别名称：</span>
            <el-input v-model="modifyBuyCk.cardTypeName" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">所属门店：</span>
            <el-input v-model="modifyBuyCk.shopName" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
        </div>
        <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
          <div style="width: 50%">
            <span style="width: 20%">适用项目：</span>
            <el-input v-model="modifyBuyCk.useTypeName" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">卡有效期：</span>
            <el-date-picker
              v-model="modifyBuyCk.validDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              size="mini">
            </el-date-picker>
          </div>
        </div>
        <div style="display: flex;justify-items: center; justify-content: space-around; width: 100%; margin-top: 10px;">
          <div style="width: 50%">
            <span style="width: 20%">可用次数：</span>
            <el-input v-model="modifyBuyCk.cardNum" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
          <div style="width: 50%">
            <span style="width: 20%">剩余次数：</span>
            <el-input v-model="modifyBuyCk.syNum" readonly
                      size="mini" style="width: 70%;"></el-input>
          </div>
        </div>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeModifyCustomerCk">取 消</el-button>
        <el-button size="mini" @click="editCustomerBuyCk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      value1:'',
      customerId:'',
      authorities:'',
      currentOrgId:'',
      userId:'',
      customerBuyCkList:[],
      queryText:'',
      rechargeStateText:[
        {state:1,name:'正常'},
        {state:4,name:'作废'}
      ],
      currentPage: 1,
      pageSize:20,
      pageTotal:0,

      pickerOptions: {
        disabledDate: this.disabledDate
      },
      lockDate:'',
      selectAreaId:'',
      selectOrgId:'',
      area:[],
      shop:[],
      orgLevel:'',
      baseRequest:{
        selectDate:'',
        startDate:'',
        endDate:'',
        shopId:'',
        pageNum:0,
        pageSize:99999,
        areaId:''
      },
      modifyCustomerCkDialogVisible:false,
      modifyBuyCk:'',
      czhj:0,
      today:''
    }
  },
  methods:{
    orderStateColor({row,columnIndex}){
      if (row.state === 1 && columnIndex ===6){
        return 'color:#0CB618';
      } else if (row.state === 4 && columnIndex ===6){
        return 'color:#EA1B28';
      } else if (row.state === 2 && columnIndex ===6){
        return 'color:#FAAC58';
      } else if (row.state === 3 && columnIndex ===6){
        return 'color:#ff1a1a';
      }
    },
    cardStateFormatter(row){
      let value = "";
      for (let i = 0; i < this.rechargeStateText.length; i++){
        let item = this.rechargeStateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadRecharges();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadRecharges();
    },
    selectKpiData(){
      if (this.baseRequest.selectDate === null){
        this.baseRequest.startDate = this.getCurrentMonthLast();
        this.baseRequest.endDate = this.getCurrentMonthLast();
      } else {
        this.baseRequest.startDate = this.baseRequest.selectDate[0];
        this.baseRequest.endDate = this.baseRequest.selectDate[1];
      }
    },
    async getArea(data){
      await this.loadShop(data);
    },
    async loadShop(areaId){
      if (areaId !== '' ){
        const {data:res} = await this.$http.get(`/orgs/area/orgId/${areaId}`);
        this.shop = res.data;
      }
      if (areaId === ''){
        this.shop = [];
        this.selectOrgId = '';
      }
    },
    getShop(data){
      this.selectOrgId = data;
      if (data === ''){
        this.selectOrgId = '';
      }
    },
    async loadCustomerBuyCkList(){
      this.czhj = 0;
      if(this.selectOrgId == ''){
        if(this.orgLevel == 1){
          this.baseRequest.areaId = this.selectAreaId;
          this.baseRequest.shopId = 0;
        }
        if(this.orgLevel == 2){
          this.baseRequest.areaId = this.currentOrgId;
          this.baseRequest.shopId = 0;
        }
        if(this.orgLevel == 3){
          this.baseRequest.areaId = 0;
          this.baseRequest.shopId = this.currentOrgId;
        }
      } else {
        this.baseRequest.shopId = this.selectOrgId;
      }
      const {data:res} = await this.$http.post('/load/customer/ci/card', this.baseRequest);
      this.customerBuyCkList = res.data;

      this.customerBuyCkList.map((item)=>{
        this.czhj += (item.money - 0)
      })
    },
    async loadAreaOrgs(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.currentOrgId}`);
      if (res.code === 200){
        this.area = res.data;
      }
    },
    showModifyCustomerCk(row){
      this.modifyBuyCk = row;
      this.modifyCustomerCkDialogVisible = true;
    },
    closeModifyCustomerCk(){
      this.modifyCustomerCkDialogVisible = false;
    },
    async editCustomerBuyCk(){
      const {data:res} = await this.$http.post(`/edit/buy/ck`, this.modifyBuyCk);
      if (res.code == 200){
        this.$message.success("操作成功！")
      }
      this.closeModifyCustomerCk();
    },
    async cancelCustomerCk(row){
      const {data:res} = await this.$http.post(`/cancel/ci/card`, row);
      if (res.code == 200){
        this.$message.success("操作成功！")
      }
      await this.loadCustomerBuyCkList();
    },
    getCurrentDate(){
      let today = new Date();
      let year = today.getFullYear();//获取年份
      let month = today.getMonth() + 1;//获取月份
      let day = today.getDate();//获取日期
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      return year + "-" + month + "-" + day;
    }

  },
  created() {
    // this.loadLockDate();
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    // this.queryRecharge();
    // this.loadOrgPayType();
    if (this.orgLevel == 1){
      this.loadAreaOrgs();
    }
    if (this.orgLevel == 2){
      this.loadShop(this.currentOrgId);
    }
    this.today = this.getCurrentDate();
    // if (this.orgLevel > 1){
    //   this.loadShop(this.currentOrgId);
    // }
  }
}
</script>

<style lang="less" scoped>
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog{
  background: #fafaff !important;
}
/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}
/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BuyCkList.vue